import { Component, inject } from '@angular/core';

import { injectTranslate, TranslatePipe } from '@core/i18n-legacy';
import { TellentCurrentUserDataFacade } from '@core/tellent-logic';
import { AddMemberFlowSelectionCardI, SeatKind, UserInvitationFlow } from '@core/tellent-types';
import {
  DialogBodyComponent,
  DialogComponent,
  DialogHeaderComponent,
} from '@core/user-interface-legacy';

import { UserInvitationFlowSelectionCardComponent } from './user-invitation-flow-selection-card/user-invitation-flow-selection-card.component';

type AddMemberFlowSelectionDialogData = {};

@Component({
  selector: 'tla-user-invitation-flow-selection-dialog',
  imports: [
    DialogHeaderComponent,
    DialogBodyComponent,
    UserInvitationFlowSelectionCardComponent,
    TranslatePipe,
  ],
  templateUrl: './user-invitation-flow-selection-dialog.component.html',
  styleUrl: './user-invitation-flow-selection-dialog.component.less',
  providers: [],
})
export class UserInvitationFlowSelectionDialogComponent extends DialogComponent<
  AddMemberFlowSelectionDialogData,
  UserInvitationFlow | undefined
> {
  private readonly t = injectTranslate();
  private readonly currentUserFacade = inject(TellentCurrentUserDataFacade);

  public isCoreHrAvailable = this.currentUserFacade.seatByKind(SeatKind.CoreHR);

  public cardOptions: AddMemberFlowSelectionCardI[] = [
    {
      heading: this.t('tlc.members.add_member_flow_choice_dialog.options.invite_member.heading'),
      subheading: this.t(
        'tlc.members.add_member_flow_choice_dialog.options.invite_member.subheading',
      ),
      icon: 'person-add',
      flowType: this.isCoreHrAvailable()
        ? UserInvitationFlow.InviteMemberAdvanced
        : UserInvitationFlow.InviteMemberBasic,
    },
    {
      heading: this.t(
        'tlc.members.add_member_flow_choice_dialog.options.add_employee_without_access.heading',
      ),
      subheading: this.t(
        'tlc.members.add_member_flow_choice_dialog.options.add_employee_without_access.subheading',
      ),
      icon: 'playlist-add',
      flowType: UserInvitationFlow.AddEmployeeWithoutAccess,
    },
    {
      heading: this.t(
        'tlc.members.add_member_flow_choice_dialog.options.add_employee_for_preonboarding.heading',
      ),
      subheading: this.t(
        'tlc.members.add_member_flow_choice_dialog.options.add_employee_for_preonboarding.subheading',
      ),
      icon: 'preonboarding-journey',
      flowType: UserInvitationFlow.AddEmployeeForPreonboarding,
    },
  ];

  public selectFlow(flowType: UserInvitationFlow) {
    this.dialogRef.close(flowType);
  }
}
